<div class="flex-column container flex max-w-full bg-white">
    <div class="bg-white md:hidden">
        <h2 class="p-4 text-left text-base font-normal leading-5 text-grey-dark dark:text-contrast-yellow">
            {{ 'SELECT_ORIGIN_AND_DESTINATION' | translate }}
        </h2>
    </div>
    <div class="hidden py-2 md:block">
        <h1 class="text-left text-base font-bold leading-5">
            {{ 'SELECT_ORIGIN_AND_DESTINATION' | translate }}
        </h1>
        <div
            class="pt-2 text-left text-xs font-medium leading-5 text-grey-dark dark:text-contrast-yellow"
            *ngIf="env.PURCHASE_FLOW.ADDITIONAL_DESCRIPTION_FROM_A_TO_B">
            <p innerHtml="{{ 'SELECT_ORIGIN_AND_DESTINATION_DESCRIPTION_0' | translate }}"></p>
            <p innerHtml="{{ 'SELECT_ORIGIN_AND_DESTINATION_DESCRIPTION_1' | translate }}"></p>
        </div>
    </div>
    <div
        class="flex-column z-10 flex gap-4 bg-white px-4 pb-2 shadow-md md:flex-row md:justify-between md:px-0 md:shadow-none">
        <ion-item class="w-full" (click)="handleAreaClicked(ModalType.original)" lines="none" detail="false" button>
            <ion-icon
                class="text-grey-zambezy dark:text-contrast-black"
                title="{{ 'ORIGIN' | translate }}"
                attr.aria-label="{{ 'ORIGIN' | translate }}"
                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product-area/origin.svg"></ion-icon>
            <ion-label>
                <span class="text-grey-zambezy dark:text-contrast-black">
                    {{ 'LOCAL_LABEL_FROM' | translate }}:&nbsp;
                </span>
                <ng-container *ngIf="originArea?.name; else noOriginArea">
                    <span class="dark:text-contrast-black">{{
                        originArea.name | translateObjectField: null : currentLanguage
                    }}</span>
                </ng-container>
                <ng-template #noOriginArea>
                    <span>{{ 'SELECT_AREA' | translate }}</span>
                </ng-template>
            </ion-label>
            <ion-icon
                class="text-grey-zambezy dark:text-contrast-black"
                attr.aria-label="{{ 'CHEVRON_DOWN' | translate }}"
                name="chevron-down">
            </ion-icon>
        </ion-item>

        <ion-item class="w-full" (click)="handleAreaClicked(ModalType.destination)" lines="none" detail="false" button>
            <ion-icon
                class="vl-app-light:text-grey-zambezy var-app-light:text-grey-zambezy text-old_silver h-7 w-7 dark:text-contrast-black"
                title="{{ 'DESTINATION' | translate }}"
                attr.aria-label="{{ 'DESTINATION' | translate }}"
                src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product-area/destination.svg"></ion-icon>
            <ion-label>
                <span class="var-app-light:text-grey-zambezy text-ironside_grey dark:text-contrast-black"
                    >{{ 'LOCAL_LABEL_TO' | translate }}:&nbsp;
                </span>
                <ng-container *ngIf="destinationArea?.name; else noDestinationArea">
                    <span class="dark:text-contrast-black">{{
                        destinationArea.name | translateObjectField: null : currentLanguage
                    }}</span>
                </ng-container>
                <ng-template #noDestinationArea>
                    <span>{{ 'SELECT_AREA' | translate }}</span>
                </ng-template>
            </ion-label>
            <ion-icon
                class="text-ironside_grey dark:text-contrast-black"
                attr.aria-label="{{ 'CHEVRON_DOWN' | translate }}"
                name="chevron-down">
            </ion-icon>
        </ion-item>
    </div>
</div>

<ion-modal class="area-modal" [isOpen]="!!modalType" (ionModalDidDismiss)="handleModalDismiss()">
    <ng-template>
        <div class="flex-column flex max-h-[85vh]">
            <div class="relative flex h-16 items-center justify-center px-4">
                {{
                    (modalType === ModalType.original ? 'SELECT_ORIGIN_AREA_LABEL' : 'SELECT_ORIGIN_DESTINATION_LABEL')
                        | translate
                }}
                <ion-button
                    class="absolute right-0 top-1.5"
                    [attr.aria-label]="'LOCAL_BTN_BACK' | translate"
                    (click)="handleAreaClicked(null)"
                    fill="clear">
                    <ion-icon
                        class="dark:filter-yellow"
                        title="{{ 'LOCAL_BTN_BACK' | translate }}"
                        aria-label="{{ 'LOCAL_BTN_BACK' | translate }}"
                        src="{{ assetsPath$ | async }}/img/purchase-flow-v2/product-area/icon-cross.svg"></ion-icon>
                </ion-button>
            </div>
            <div class="flex-column flex flex-1 gap-4 overflow-y-auto px-4">
                <ng-container *ngFor="let option of productAreas">
                    <ion-chip
                        class="m-0 flex h-8 justify-center rounded-full border border-solid dark:border-contrast-yellow dark:text-contrast-yellow"
                        [ngClass]="{
                            'border-primary font-bold':
                                (modalType === ModalType.original
                                    ? preselectedOriginArea?.id
                                    : preselectedDestinationArea?.id) === option.id
                        }"
                        [outline]="
                            (modalType === ModalType.original
                                ? preselectedOriginArea?.id
                                : preselectedDestinationArea?.id) === option.id
                        "
                        (click)="areaSelected(option)">
                        {{ option.name | translateObjectField: null : currentLanguage }}
                    </ion-chip>
                </ng-container>
            </div>

            <div class="p-4">
                <ion-button
                    class="m-0 w-full"
                    [attr.aria-label]="'BUTTON_SELECT' | translate"
                    [disabled]="
                        !(modalType === ModalType.original ? preselectedOriginArea : preselectedDestinationArea)
                    "
                    (click)="handleSelectAreaClick()"
                    size="large"
                    color="secondary"
                    slot="end">
                    <ion-label class="text-base font-bold normal-case">
                        {{ 'BUTTON_SELECT' | translate }}
                    </ion-label>
                </ion-button>
            </div>
        </div>
    </ng-template>
</ion-modal>
